'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
export function NoResults() {
  const $ = _c(4);
  const t = useTranslations("markets");
  let t0;
  if ($[0] !== t) {
    t0 = t("noResults");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <p className="text-foreground-secondary text-center py-12 col-span-full">{t0}</p>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}